// KILL: Eventually remove redux-form and this reducer

import { Dictionary } from 'lodash';
import { AnyAction } from 'redux';

// TODO: import { reducer as reduxFormReducer } from 'redux-form';
const reduxFormReducer = require('redux-form').reducer;

export type State = Dictionary<{
    error: string | null;
    _successMessage: string | null;
    values: Dictionary<any>;
    initial: Dictionary<any>;
}>;

export const initialState = Object.freeze<State>({});

export const formReducer = (state: State = initialState as any, action: AnyAction) => {
    return reduxFormReducer(state, action);
};
